<div class="carousel-container" [style.width.px]="configuration().width">
  <!-- Main carousel content -->
  <div class="carousel-wrapper" [class.min-h-[144px]]="hasMedia()">
    <div class="carousel-content" [class.min-h-[144px]]="hasMedia()">
      @for (slide of slidesToDisplay(); track trackBySlideIndex($index, slide)) {
        <div
          #slideContainer
          class="carousel-slide"
          [class.carousel-slide-previous]="slide.position === 'previous'"
          [class.slide-in-from-right]="
            slide.position === 'current' && isTransitioning() && slideDirection() === 'right'
          "
          [class.slide-in-from-left]="slide.position === 'current' && isTransitioning() && slideDirection() === 'left'"
          [class.slide-out-to-left]="slide.position === 'previous' && slideDirection() === 'right'"
          [class.slide-out-to-right]="slide.position === 'previous' && slideDirection() === 'left'"
          [style.min-height.px]="stableHeight()"
        >
          @if (slide.item.isYoutubeContent && slide.item.src) {
            <app-youtube-player-iframe [videoUrl]="slide.item.src" [maxHeight]="configuration().maxHeight ?? 360" />
          } @else if (slide.item.mediaType === 'video') {
            <app-video-player
              [configuration]="{
                src: slide.item.src,
                controls: true,
                muted: true,
                width: configuration().width ?? defaultWidth,
                height: configuration().maxHeight,
              }"
              [videoPlayedContext]="configuration().videoPlayedContext ?? null"
            />
          } @else {
            <app-icon-badge
              backgroundColor="transparent"
              [content]="slide.item.src"
              [alt]="slide.item.alt"
              [width]="configuration().width ?? defaultWidth"
              [maxHeight]="configuration().maxHeight ?? null"
            />
          }
        </div>
      }
    </div>

    <!-- Navigation Controls -->
    @if (hasMultipleItems() && (configuration().showControls ?? true)) {
      <button
        type="button"
        class="carousel-control carousel-control-prev"
        aria-label="Previous media"
        [disabled]="isTransitioning()"
        (click)="previousSlide()"
      >
        <app-icon src="icons/chevron-left.svg" alt="Previous" class="w-4 h-4" />
      </button>

      <button
        type="button"
        class="carousel-control carousel-control-next"
        aria-label="Next media"
        [disabled]="isTransitioning()"
        (click)="nextSlide()"
      >
        <app-icon src="icons/chevron-right.svg" alt="Next" class="w-4 h-4" />
      </button>
    }
  </div>

  <!-- Indicators -->
  @if (hasMultipleItems() && (configuration().showIndicators ?? true)) {
    <div class="carousel-indicators">
      @for (item of configuration().items; track $index) {
        <button
          type="button"
          class="carousel-indicator"
          [class.active]="currentIndex() === $index"
          (click)="goToSlide($index)"
          [disabled]="isTransitioning()"
          [attr.aria-label]="'Go to slide ' + ($index + 1)"
        ></button>
      }
    </div>
  }
</div>
